import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import auth, { onboardCompany } from "src/firebase";
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  USER_SET,
  SET_CURRENT_COMPANY,
  SET_USER_COMPANIES,
} from "../actions/auth.action.js";

export const createUser = (email, password, displayName) => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      createUserWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
          if (displayName) {
            await updateProfile(userCredential.user, {
              displayName: displayName,
            });
          }
          localStorage.setItem("user", JSON.stringify(userCredential.user));
          localStorage.setItem(
            "accessToken",
            JSON.stringify(userCredential.user.accessToken)
          );
          dispatch({ type: LOGIN_SUCCESS, payload: userCredential.user });
          resolve(userCredential);
        })
        .catch((error) => {
          dispatch({ type: LOGIN_FAILURE, payload: error.message });
          reject(error);
        });
    });
};

export const setUser = (user) => {
  return (dispatch) =>
    new Promise((resolve) => {
      dispatch({ type: USER_SET, payload: user });
      resolve(user);
    });
};

export const setCurrentCompany = (company) => {
  return (dispatch) =>
    new Promise((resolve) => {
      dispatch({ type: SET_CURRENT_COMPANY, payload: company });
      localStorage.setItem("currentCompany", JSON.stringify(company));
      resolve(company);
    });
};

export const loadCachedCompany = () => {
  return (dispatch) =>
    new Promise((resolve) => {
      console.log("Loading cached company...");
      const cachedCompany = localStorage.getItem("currentCompany");
      if (cachedCompany) {
        try {
          const company = JSON.parse(cachedCompany);
          dispatch({ type: SET_CURRENT_COMPANY, payload: company });
          resolve(company);
        } catch (error) {
          console.error("Error parsing cached company:", error);
          localStorage.removeItem("currentCompany");
          resolve(null);
        }
      } else {
        resolve(null);
      }
    });
};

export const setUserCompanies = (companies) => {
  return (dispatch, getState) =>
    new Promise((resolve) => {
      // Filter companies to only include those where user has write permissions
      console.log("Setting user companies...", companies);
      const writableCompanies = companies.filter(company =>
        company.roles?.owner === true || // TODO: REMOVE legacy
        company.roles?.admin === true);
      // Get current company from Redux state
      const currentCompanyInState = getState().user.company;

      if (writableCompanies.length > 0) {
        const cachedCompany = JSON.parse(localStorage.getItem("currentCompany") || "null");
        let newSelectedCompany;
        let shouldRefreshCurrentCompany = false;

        if (cachedCompany) {
          const selectedCompany = writableCompanies.find(
            (company) => company.id === cachedCompany.id
          );
          newSelectedCompany = selectedCompany || writableCompanies[0];

          if (selectedCompany) {
            const cachedCompanyJson = JSON.stringify(cachedCompany);
            const selectedCompanyJson = JSON.stringify(selectedCompany);
            if (cachedCompanyJson !== selectedCompanyJson) {
              localStorage.setItem("currentCompany", selectedCompanyJson);
              if (currentCompanyInState?.id === selectedCompany.id) {
                shouldRefreshCurrentCompany = true;
              }
            }
          }
        } else {
          newSelectedCompany = writableCompanies[0];
        }

        // Only dispatch SET_CURRENT_COMPANY if the company actually changes
        if (!currentCompanyInState || currentCompanyInState.id !== newSelectedCompany.id || shouldRefreshCurrentCompany) {
          dispatch({ type: SET_CURRENT_COMPANY, payload: newSelectedCompany });
          localStorage.setItem("currentCompany", JSON.stringify(newSelectedCompany));
        }
      } else {
        // Only dispatch if we currently have a company set
        if (currentCompanyInState) {
          dispatch({ type: SET_CURRENT_COMPANY, payload: null });
          localStorage.removeItem("currentCompany");
        }
      }

      dispatch({ type: SET_USER_COMPANIES, payload: writableCompanies });
      resolve(writableCompanies);
    });
}

export const onboardNewCompany = (onboardingData) => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      console.log("Onboarding new company with data:", onboardingData);
      onboardCompany(onboardingData)
        .then((result) => {
          console.log("Onboard company result:", result.data.company);
          dispatch({ type: SET_CURRENT_COMPANY, payload: result.data.company });
          localStorage.setItem("currentCompany", JSON.stringify(result.data.company));
          resolve(result.data.company);
        })
        .catch((error) => {
          console.log("Error onboarding company:", error);
          dispatch({ type: SET_CURRENT_COMPANY, payload: null });
          localStorage.removeItem("currentCompany");
          reject(error);
        });
    });
}


export const login = (email, password) => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          console.log(userCredential);
          dispatch({ type: LOGIN_SUCCESS, payload: userCredential.user });
          localStorage.setItem("user", JSON.stringify(userCredential.user));
          localStorage.setItem(
            "accessToken",
            JSON.stringify(userCredential.user.accessToken)
          );
          resolve(userCredential);
        })
        .catch((error) => {
          console.log("ERROR LOGIN", error);
          dispatch({ type: LOGIN_FAILURE, payload: error.message });
          reject(error);
        });
    });
};

export const logout = () => {
  return (dispatch) => new Promise((resolve) => {
    signOut(auth).then(() => {
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      dispatch({ type: LOGOUT_SUCCESS });
      resolve();
    });
  });
};
